import { render, staticRenderFns } from "./courseEdit.vue?vue&type=template&id=0b95443c&scoped=true"
import script from "./courseEdit.vue?vue&type=script&lang=js"
export * from "./courseEdit.vue?vue&type=script&lang=js"
import style0 from "./courseEdit.vue?vue&type=style&index=0&id=0b95443c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b95443c",
  null
  
)

export default component.exports